export default {"src":"/_next/static/media/front-yard.a355f72c.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};